var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmitPromptIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 60.5,
    stroke: "#EE7470",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6333 71.56L57.5453 39.88H66.4413L65.3533 71.56H58.6333ZM61.9613 85.64C60.5533 85.64 59.3373 85.128 58.3133 84.104C57.2893 83.08 56.7773 81.864 56.7773 80.456C56.7773 79.0053 57.2893 77.768 58.3133 76.744C59.3373 75.72 60.5533 75.208 61.9613 75.208C63.4119 75.208 64.6493 75.72 65.6733 76.744C66.6973 77.768 67.2093 79.0053 67.2093 80.456C67.2093 81.864 66.6973 83.08 65.6733 84.104C64.6493 85.128 63.4119 85.64 61.9613 85.64Z",
    fill: "#CC2442"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitPromptIcon);
export default __webpack_public_path__ + "static/media/submit-prompt-icon.723414541608a3b4ca586f91be150b2b.svg";
export { ForwardRef as ReactComponent };